exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".erg-components-Pagination li{vertical-align:middle;cursor:pointer}.erg-components-Pagination li.paggination-dots{cursor:default}", "", {"version":3,"sources":["/./node_modules/@ergeon/erg-components-react/lib/table/node_modules/@ergeon/erg-components-react/lib/table/Pagination.scss"],"names":[],"mappings":"AAAA,8BAEI,sBACA,cAAe,CAHnB,+CAMI,cAAe,CAChB","file":"Pagination.scss","sourcesContent":[".erg-components-Pagination {\n  li {\n    vertical-align: middle;\n    cursor: pointer;\n  }\n  li.paggination-dots {\n    cursor: default;\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?sourceMap!./~/sass-loader?sourceMap&includePaths[]=/home/circleci/project/bower_components&includePaths[]=/home/circleci/project/node_modules!./~/postcss-loader!./~/@ergeon/erg-components-react/lib/table/Pagination.scss
 ** module id = 1155
 ** module chunks = 0
 **/